<!-- 菜单导航 -->
<template>
  <div class="MenuNav">
    <el-menu :default-active="tagCurrent" class="el-menu-vertical" router :background-color="less.navBg" :text-color="less.navText" :active-text-color="less.navActiveText">
      <el-menu-item v-for="item in navsInitMenuData" :key="item.name" :index="item.name" :route="`${item.path}`">
        <el-icon>
          <i class="iconfont" v-html="item.icon"></i>
        </el-icon>
        <template #title>
          <span>
            {{ item.title }}
          </span>
        </template>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script setup lang="ts">
import less from "@/styles/base.module.less";
import { ref } from "vue";
const navsInitMenuData: Record<string, string>[] = [
  { title: "订单明细", path: "/orderDetail", name: "orderDetail", icon: "&#xe763;" },
  // { title: "发票明细", path: "/invoiceDetail", name: "invoiceDetail", icon: "&#xe764;" },
];
const tagCurrent = ref<string>("orderDetail");
</script>
<style lang="less" scoped>
.MenuNav {
  width: 100%;
  height: 100%;
  .el-menu-vertical {
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    &:not(.el-menu--collapse) {
      min-height: 400px;
      height: 100%;
      font-size: 14px;
      overflow: hidden;
      border: none;
      .el-menu-item {
        padding-left: 20px;
      }
      .el-menu-item.is-active {
        background-color: var(--el-menu-hover-bg-color);
      }
      :deep(.el-badge__content.is-fixed) {
        right: 0;
        --el-transition-duration: 0;
      }
    }
  }
}
</style>
